import { GET_LEAVE_REQUESTS } from '../../endpoints';
import { ILeaveRequest } from '../../types/leave';
import makeAuthenticatedRequest from '../base-api';

const getLeaveRequestsQueryKey = (
  status?: string,
  brandId?: string,
  kimId?: string
) => ['leave-requests', status, brandId, kimId].filter(Boolean);

const getLeaveRequests = async (params?: {
  status?: string;
  brandId?: string;
  kimId?: string;
}): Promise<{
  success: boolean;
  data?: { leaveRequests: ILeaveRequest[] };
  message?: string;
}> => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.brandId) queryParams.append('brandId', params.brandId);
    if (params?.kimId) queryParams.append('kimId', params.kimId);

    const url = `${GET_LEAVE_REQUESTS}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const response = await makeAuthenticatedRequest(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch leave requests: ${response.statusText}`);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getLeaveRequests, getLeaveRequestsQueryKey };
